module.exports = __webpack_public_path__ + "static/media/progress2.0e1a2301.png";